import Link from 'next/link';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { FeatureFlags } from 'featureFlags/constants';
import { getLinkFromSearchConfig } from 'search/utils/getLinkFromSearchConfig';
import { GIFT_CARDS_SUGGESTED_SEARCH } from 'search/enums/constants';
import { RecentSearchesCache } from 'search/utils/RecentSearchesCache';
import { SearchBoxButton } from 'search/styles/SearchStyles';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { setCurrentSearchTerm } from 'store/slice/searchSlice';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { useStoreDispatch } from 'store/hooks/storeHooks';

export const SearchSuggestions = ({ suggestedSearches, error }) => {
  const router = useRouter();
  const storeDispatch = useStoreDispatch();
  const isMicroFrontendSearch =
    router?.pathname?.includes('/new-search') || router?.pathname?.includes('/new-collections');
  const isGiftCardsSuggestSearchEnabled = useFeatureFlag(
    FeatureFlags.TEMP_WEB_ENABLE_GIFT_CARDS_SUGGESTED_SEARCH,
  );

  const handleClick = (suggestedSearch) => {
    const newEntry = JSON.stringify({
      text: suggestedSearch.title,
      link: getLinkFromSearchConfig(suggestedSearch.searchConfig),
    });

    RecentSearchesCache.add(newEntry);
    storeDispatch(setCurrentSearchTerm(suggestedSearch?.searchConfig?.query || 'TERM_UNKNOWN'));

    sendTrackingEvent('SEARCH_SUGGESTION_TAP', {
      event_context: 'search_bar',
      search_string: suggestedSearch.title,
    });
  };

  if (error || !suggestedSearches) {
    return null;
  }

  let _suggestedSearches = suggestedSearches;

  if (isGiftCardsSuggestSearchEnabled) {
    if (suggestedSearches?.[0].title === 'Shop All Items') {
      _suggestedSearches = [
        suggestedSearches?.[0],
        GIFT_CARDS_SUGGESTED_SEARCH,
        ...suggestedSearches.slice(1),
      ];
    } else {
      _suggestedSearches = [GIFT_CARDS_SUGGESTED_SEARCH, ...suggestedSearches];
    }
  }

  return (
    <SearchSuggestions.Wrapper>
      {_suggestedSearches.map((suggestedSearch) => (
        <SearchBoxButton
          key={suggestedSearch.id}
          onClick={() => handleClick(suggestedSearch)}
          data-qa="suggested_search"
        >
          <Link
            href={getLinkFromSearchConfig(suggestedSearch.searchConfig, isMicroFrontendSearch)}
            passHref
            prefetch={false}
          >
            <a>{suggestedSearch.title}</a>
          </Link>
        </SearchBoxButton>
      ))}
    </SearchSuggestions.Wrapper>
  );
};

SearchSuggestions.Wrapper = styled.div`
  margin-bottom: 24px;
`;
